/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApprovazioneLavoriDTO,
  ProblemDetails,
  RichiesteCausaliCdlApprovazioniDTO,
  RichiesteTimbratureApprovazioniDTO,
  RichiesteTimbratureApprovazioniStoricoDTO,
  RichiesteTimbratureApprovazioniStoricoUpdateDTO,
} from '../models/index';
import {
    ApprovazioneLavoriDTOFromJSON,
    ApprovazioneLavoriDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RichiesteCausaliCdlApprovazioniDTOFromJSON,
    RichiesteCausaliCdlApprovazioniDTOToJSON,
    RichiesteTimbratureApprovazioniDTOFromJSON,
    RichiesteTimbratureApprovazioniDTOToJSON,
    RichiesteTimbratureApprovazioniStoricoDTOFromJSON,
    RichiesteTimbratureApprovazioniStoricoDTOToJSON,
    RichiesteTimbratureApprovazioniStoricoUpdateDTOFromJSON,
    RichiesteTimbratureApprovazioniStoricoUpdateDTOToJSON,
} from '../models/index';

export interface DeleteApprovazioneRichiestaCausaleCdlStoricoRequest {
    id?: number;
}

export interface DeleteApprovazioneRichiestaTimbraturaStoricoRequest {
    id?: number;
}

export interface GetApprovazioniRichiesteTimbratureRequest {
    all?: boolean;
}

export interface GetRichiesteCausaliCdlApprovazioniRequest {
    all?: boolean;
    filterStato?: string;
}

export interface GetRichiesteLavoroDaApprovareRequest {
    idPersonale?: number;
}

export interface PutApprovaRichiestaCausaleCdlStoricoRequest {
    id?: number;
    note?: string;
    isApprovata?: boolean;
}

export interface PutApprovaRichiestaLavoroRequest {
    isApprovato?: boolean;
    requestBody?: Array<number>;
}

export interface PutApprovaRichiestaTimbraturaRequest {
    isApprovato?: boolean;
    idPersonale?: number;
    data?: Date;
}

export interface PutApprovazioneRichiestaCausaleCdlRequest {
    id?: number;
    richiesteCausaliCdlApprovazioniDTO?: RichiesteCausaliCdlApprovazioniDTO;
}

export interface PutApprovazioneRichiestaTimbraturaRequest {
    idPersonale?: number;
    data?: Date;
    note?: string;
}

export interface PutApprovazioneRichiestaTimbraturaStoricoRequest {
    id?: number;
    richiesteTimbratureApprovazioniStoricoUpdateDTO?: RichiesteTimbratureApprovazioniStoricoUpdateDTO;
}

/**
 * 
 */
export class ApprovazioniApi extends runtime.BaseAPI {

    /**
     */
    async deleteApprovazioneRichiestaCausaleCdlStoricoRaw(requestParameters: DeleteApprovazioneRichiestaCausaleCdlStoricoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/deleteApprovazioneRichiestaCausaleCdlStorico`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteApprovazioneRichiestaCausaleCdlStorico(requestParameters: DeleteApprovazioneRichiestaCausaleCdlStoricoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteApprovazioneRichiestaCausaleCdlStoricoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteApprovazioneRichiestaTimbraturaStoricoRaw(requestParameters: DeleteApprovazioneRichiestaTimbraturaStoricoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvazioneRichiestaTimbraturaStorico`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteApprovazioneRichiestaTimbraturaStorico(requestParameters: DeleteApprovazioneRichiestaTimbraturaStoricoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteApprovazioneRichiestaTimbraturaStoricoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getApprovazioniRichiesteTimbratureRaw(requestParameters: GetApprovazioniRichiesteTimbratureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RichiesteTimbratureApprovazioniDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['all'] != null) {
            queryParameters['all'] = requestParameters['all'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvazioniRichiesteTimbrature`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RichiesteTimbratureApprovazioniDTOFromJSON));
    }

    /**
     */
    async getApprovazioniRichiesteTimbrature(requestParameters: GetApprovazioniRichiesteTimbratureRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RichiesteTimbratureApprovazioniDTO>> {
        const response = await this.getApprovazioniRichiesteTimbratureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRichiesteCausaliCdlApprovazioniRaw(requestParameters: GetRichiesteCausaliCdlApprovazioniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RichiesteCausaliCdlApprovazioniDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['all'] != null) {
            queryParameters['all'] = requestParameters['all'];
        }

        if (requestParameters['filterStato'] != null) {
            queryParameters['filterStato'] = requestParameters['filterStato'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/richiesteCausaliCdl`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RichiesteCausaliCdlApprovazioniDTOFromJSON));
    }

    /**
     */
    async getRichiesteCausaliCdlApprovazioni(requestParameters: GetRichiesteCausaliCdlApprovazioniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RichiesteCausaliCdlApprovazioniDTO>> {
        const response = await this.getRichiesteCausaliCdlApprovazioniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRichiesteCausaliCdlApprovazioniStoricoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RichiesteCausaliCdlApprovazioniDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/richiesteCausaliCdlApprovazioniStorico`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RichiesteCausaliCdlApprovazioniDTOFromJSON));
    }

    /**
     */
    async getRichiesteCausaliCdlApprovazioniStorico(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RichiesteCausaliCdlApprovazioniDTO>> {
        const response = await this.getRichiesteCausaliCdlApprovazioniStoricoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getRichiesteLavoroDaApprovareRaw(requestParameters: GetRichiesteLavoroDaApprovareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ApprovazioneLavoriDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/richiesteLavoroDaApprovare`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApprovazioneLavoriDTOFromJSON));
    }

    /**
     */
    async getRichiesteLavoroDaApprovare(requestParameters: GetRichiesteLavoroDaApprovareRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ApprovazioneLavoriDTO>> {
        const response = await this.getRichiesteLavoroDaApprovareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRichiesteTibratureApprovazioniStoricoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RichiesteTimbratureApprovazioniStoricoDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/richiesteTibratureApprovazioniStorico`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RichiesteTimbratureApprovazioniStoricoDTOFromJSON));
    }

    /**
     */
    async getRichiesteTibratureApprovazioniStorico(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RichiesteTimbratureApprovazioniStoricoDTO>> {
        const response = await this.getRichiesteTibratureApprovazioniStoricoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async putApprovaRichiestaCausaleCdlStoricoRaw(requestParameters: PutApprovaRichiestaCausaleCdlStoricoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['note'] != null) {
            queryParameters['note'] = requestParameters['note'];
        }

        if (requestParameters['isApprovata'] != null) {
            queryParameters['isApprovata'] = requestParameters['isApprovata'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/putApprovaRichiestaCausaleCdlStorico`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovaRichiestaCausaleCdlStorico(requestParameters: PutApprovaRichiestaCausaleCdlStoricoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovaRichiestaCausaleCdlStoricoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putApprovaRichiestaLavoroRaw(requestParameters: PutApprovaRichiestaLavoroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['isApprovato'] != null) {
            queryParameters['isApprovato'] = requestParameters['isApprovato'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvaRichiestaLavoro`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovaRichiestaLavoro(requestParameters: PutApprovaRichiestaLavoroRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovaRichiestaLavoroRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putApprovaRichiestaTimbraturaRaw(requestParameters: PutApprovaRichiestaTimbraturaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['isApprovato'] != null) {
            queryParameters['isApprovato'] = requestParameters['isApprovato'];
        }

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvaRichiestaTimbratura`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovaRichiestaTimbratura(requestParameters: PutApprovaRichiestaTimbraturaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovaRichiestaTimbraturaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putApprovazioneRichiestaCausaleCdlRaw(requestParameters: PutApprovazioneRichiestaCausaleCdlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvazioneRichiestaCausaleCdl`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RichiesteCausaliCdlApprovazioniDTOToJSON(requestParameters['richiesteCausaliCdlApprovazioniDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovazioneRichiestaCausaleCdl(requestParameters: PutApprovazioneRichiestaCausaleCdlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovazioneRichiestaCausaleCdlRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putApprovazioneRichiestaTimbraturaRaw(requestParameters: PutApprovazioneRichiestaTimbraturaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        if (requestParameters['data'] != null) {
            queryParameters['data'] = (requestParameters['data'] as any).toISOString();
        }

        if (requestParameters['note'] != null) {
            queryParameters['note'] = requestParameters['note'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvazioneRichiestaTimbratura`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovazioneRichiestaTimbratura(requestParameters: PutApprovazioneRichiestaTimbraturaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovazioneRichiestaTimbraturaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async putApprovazioneRichiestaTimbraturaStoricoRaw(requestParameters: PutApprovazioneRichiestaTimbraturaStoricoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Approvazioni/approvazioneRichiestaTimbraturaStorico`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RichiesteTimbratureApprovazioniStoricoUpdateDTOToJSON(requestParameters['richiesteTimbratureApprovazioniStoricoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async putApprovazioneRichiestaTimbraturaStorico(requestParameters: PutApprovazioneRichiestaTimbraturaStoricoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putApprovazioneRichiestaTimbraturaStoricoRaw(requestParameters, initOverrides);
    }

}
